<template>
  <div>
    <div class="d-inline-flex mb-4">
      <div class="form-check mr-3">
        <input
          class="form-check-input select-all mt-0"
          type="checkbox"
          v-model="selectAll"
        />
      </div>
      <h4 class="mr-3 mb-0">
        Voice
      </h4>
      <div class="d-flex align-items-center mr-3">
        <span class="cursor-pointer" @click="addNewTts()">
          <img
            src="~@/assets/addplus_icon.svg"
            width="20"
            class="heading-icon"
          />
        </span>
        <span
          v-if="isSelected"
          class="cursor-pointer ml-3"
          @click="deleteAllTts()"
        >
          <i class="fa fa-trash"></i>
        </span>
      </div>
    </div>
    <div v-for="(ttsitem, index) in tts_fields" :key="index" class="mb-3">
      <div class="fields-wrapper is-divider is-multi-node">
        <div class="form-check select-single">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="ttsitem.textToSpeech.selectSingle"
          />
          <!-- @change="checkSingleSelect" -->
        </div>
        <div
          class="action-buttons"
          v-if="
            !ttsitem.textToSpeech.isCopied || ttsitem.textToSpeech.selectSingle
          "
        >
          <span
            v-if="!ttsitem.textToSpeech.isCopied"
            class="action-item "
            @click="copyTts(index, ttsitem)"
          >
            <i class="fa fa-copy"></i>
          </span>
          <span
            v-if="ttsitem.textToSpeech.selectSingle"
            class="action-item"
            @click="deleteTts(index, ttsitem)"
          >
            <i class="fa fa-trash"></i>
          </span>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                Voice Type
              </label>
              <div class="col-sm-7">
                <select
                  class="custom-select"
                  v-model="ttsitem.textToSpeech.gender"
                  @change="getVoicesList(index)"
                >
                  <option v-for="voice in voices" :key="voices.indexOf(voice)"
                    >{{ voice }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                Select Language
              </label>
              <div class="col-sm-7">
                <select
                  class="custom-select"
                  v-model="ttsitem.textToSpeech.languageCode"
                  @change="getVoiceEffects(index)"
                >
                  <option
                    v-for="voice in ttsitem.textToSpeech.voiceList"
                    :value="voice"
                    :key="ttsitem.textToSpeech.voiceList.indexOf(voice)"
                    >{{ voice.country }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                Voice Effect
              </label>
              <div class="col-sm-7">
                <select
                  class="custom-select"
                  v-model="ttsitem.textToSpeech.voiceEffect"
                  @change="getDataWithNewFields(index)"
                >
                  <option
                    v-for="effect in ttsitem.textToSpeech.voiceEffects"
                    :value="effect.name"
                    :key="ttsitem.textToSpeech.voiceEffects.indexOf(effect)"
                    >{{ effect.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                Voice Text
              </label>
              <div class="col-sm-7">
                <textarea
                  class="form-control"
                  :ref="'textToSpeech-' + index"
                  rows="4"
                  v-model="ttsitem.textToSpeech.text"
                  :id="'targetIdle-' + index"
                  @keyup="setTimer"
                  @click="deleteText(index, ttsitem.textToSpeech.text)"
                  placeholder="Please enter your voice text here"
                >
                </textarea>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                Test Voice
              </label>
              <div class="col-sm-7">
                <template
                  v-if="
                    !ttsitem.textToSpeech.hasOwnProperty('isAudioPlaying') ||
                      !ttsitem.textToSpeech.isAudioPlaying
                  "
                >
                  <button
                    @click="playTextToSpeech(index)"
                    class="btn btn-outline-success"
                    id="select_audio_duration_s"
                  >
                    <i class="fa fa-play"></i>
                  </button>
                </template>
                <template
                  v-if="
                    ttsitem.textToSpeech.hasOwnProperty('isAudioPlaying') &&
                      ttsitem.textToSpeech.isAudioPlaying
                  "
                >
                  <button
                    @click="pauseSound(index)"
                    class="btn btn-outline-warning"
                    id="select_audio_duration_pause"
                  >
                    <i class="fa fa-pause pause"></i>
                  </button>
                </template>
                <button
                  @click="stopSound(index)"
                  class="btn btn-outline-danger"
                  id="select_audio_duration_stop"
                >
                  <i class="fa fa-stop"></i>
                </button>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                Voice Volume
              </label>
              <div class="col-sm-7">
                <input
                  type="range"
                  min="0"
                  max="10"
                  step="0.5"
                  v-model="ttsitem.textToSpeech.voiceVolume"
                />
                <span class="ml-3">{{ ttsitem.textToSpeech.voiceVolume }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                Start Time
              </label>
              <div class="col-sm-7">
                <input
                  type="number"
                  :id="index"
                  @blur="checkStartTime"
                  v-model="ttsitem.textToSpeech.startTime"
                  :min="
                    index !== 0
                      ? parseInt(tts_fields[index - 1].textToSpeech.endTime) +
                        parseInt(2)
                      : 0
                  "
                  class="form-control"
                />
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                End Time
              </label>
              <div class="col-sm-7">
                <input
                  type="text"
                  v-model="ttsitem.textToSpeech.endTime"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-5 col-form-label">
                Duration (sec)
              </label>
              <div class="col-sm-7">
                <input
                  type="text"
                  v-model="ttsitem.textToSpeech.duration"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '../../../../../firebaseDB'
import { uuid } from 'vue-uuid'
import { mapState } from 'vuex'

export default {
  components: {},
  data () {
    return {
      tts_fields: [],
      selectAll: false,
      isSelected: false,
      voices: ['Male', 'Female', 'WaveNet Male', 'WaveNet Female'],
      audioObject: new Audio(),
      voicesData: [],
      idleTimer: 0,
      idleInterval: null,
      currentTime: null,
      currentPlayingIndex: null,
      activeModel: {},
      mountedAlready: false
    }
  },
  watch: {
    selectAll: function (val) {
      this.isSelected = !!val
      if (this.tts_fields) {
        this.tts_fields.forEach(value => {
          value.textToSpeech.selectSingle = val
        })
      }
    },
    characters (val) {
      this.activeModel = {}
      this.tts_fields = []
      for (let i = 0; i < val.length; i++) {
        const char = val[i]
        !char.object3DElements && (char.object3DElements = [])
        if (char.active) {
          this.activeModel = char
          if (this.activeModel.hasOwnProperty('object3DElements')) {
            this.tts_fields = this.activeModel.object3DElements && this.activeModel.object3DElements.filter(
              el => {
                return el.hasOwnProperty('textToSpeech')
              }
            )
            setTimeout(() => {
              let newArray = []
              this.tts_fields.forEach((value, index) => {
                this.getVoicesList(index)
                this.getVoiceEffects(index)
                newArray.push(value)
              })
              this.tts_fields = newArray
            }, 1000)
          }
        }
      }
    },
    tts_fields () {}
  },
  beforeDestroy() {
    this.$root.$off('addTts');
   },
  created () {
    if (!this.mountedAlready) {
      this.$root.$on('addTts', () => {
        console.log('addTts')
        setTimeout(() => {
          this.addNewTts()
        }, 200)
      })
      this.mountedAlready = true
    }
    db.ref(`assets/asset_data/voice`)
      .once('value')
      .then(snapshot => {
        this.voicesData = Object.values(snapshot.val())
      })
  },
  methods: {
    addNewTts () {
      if (this.activeModel) {
        let startTime = this.tts_fields.length ? 
          this.tts_fields[this.tts_fields.length - 1].textToSpeech.endTime : 
          parseFloat(this.activeModel.startTime);
        let newOne = {
          elementType: 'TextToSpeech',
          id: uuid.v1(),
          textToSpeech: {
            country: '',
            gender: '',
            text: '',
            languageCode: '',
            voiceEffect: '',
            voiceName: '',
            voiceVolume: 1,
            startTime: parseFloat(startTime),
            endTime: parseFloat(startTime) + 10,
            duration: 10,
            voiceList: [],
            voiceEffects: [],
            isCopied: false,
            selectSingle: false
          }
        }
        this.tts_fields.push(newOne)
        console.log(this.tts_fields)
        if (this.tts_fields.length === 1) {
          this.tts_fields[this.tts_fields.length - 1].textToSpeech.gender =
            'Male'
          this.getVoicesList(this.tts_fields.length - 1)
          this.tts_fields[
            this.tts_fields.length - 1
          ].textToSpeech.languageCode = this.tts_fields[
            this.tts_fields.length - 1
          ].textToSpeech.voiceList[3]
          this.getVoiceEffects(this.tts_fields.length - 1)
          this.tts_fields[
            this.tts_fields.length - 1
          ].textToSpeech.voiceEffect = this.tts_fields[
            this.tts_fields.length - 1
          ].textToSpeech.voiceEffects[0].name
        } else {
          this.tts_fields[
            this.tts_fields.length - 1
          ].textToSpeech.gender = this.tts_fields[
            this.tts_fields.length - 2
          ].textToSpeech.gender
          this.getVoicesList(this.tts_fields.length - 1)
          this.tts_fields[
            this.tts_fields.length - 1
          ].textToSpeech.languageCode = this.tts_fields[
            this.tts_fields.length - 2
          ].textToSpeech.languageCode
          this.getVoiceEffects(this.tts_fields.length - 1)
          this.tts_fields[
            this.tts_fields.length - 1
          ].textToSpeech.voiceEffect = this.tts_fields[
            this.tts_fields.length - 2
          ].textToSpeech.voiceEffect
        }
        this.tts_fields[
          this.tts_fields.length - 1
        ].textToSpeech.text = this.tts_fields[
          this.tts_fields.length - 1
        ].textToSpeech.placeHolderText = 'Please enter your voice text here'
        let newChar =
          this.characters &&
          this.characters.map(char =>
            char.objectId === this.activeModel.objectId
              ? {
                ...char,
                active: true,
                object3DElements: [...char.object3DElements, newOne]
              }
              : { ...char }
          )
        this.$store.dispatch('updateCharacters', newChar)
      } else {
        this.$toast('Please select a character first to add voice to it !', {
          timeout: 3000,
          type: 'error',
          showCloseButtonOnHover: true
        })
      }
    },
    checkStartTime (event) {
      let index = parseInt(event.target.id)
      if (
        index !== 0 &&
        (parseInt(this.tts_fields[index].textToSpeech.startTime) <
          parseInt(this.tts_fields[index - 1].textToSpeech.endTime) ||
          parseInt(this.tts_fields[index].textToSpeech.startTime) >
            parseInt(this.tts_fields[index].textToSpeech.endTime))
      ) {
        this.tts_fields[index].textToSpeech.startTime =
          parseFloat(
            this.tts_fields[index - 1].textToSpeech.endTime.toFixed(2)
          ) + parseFloat(1)
      }
      this.tts_fields[index].textToSpeech.endTime = parseFloat(this.tts_fields[index].textToSpeech.startTime) +
        parseFloat (this.tts_fields[index].textToSpeech.duration)
    },
    pauseSound (index) {
      this.audioObject && this.audioObject.pause()
      this.tts_fields[
        index
      ].textToSpeech.currentTime = this.audioObject.currentTime
      this.tts_fields[index].textToSpeech.isAudioPlaying = false
      this.tts_fields[index].textToSpeech.audioPlayComplete = false
      this.tts_fields[index].textToSpeech = {
        ...this.tts_fields[index].textToSpeech
      }
      this.currentPlayingIndex = index
    },
    stopSound (index) {
      if (this.audioObject.src) {
        this.tts_fields[index].textToSpeech.isAudioPlaying = false
        this.tts_fields[index].textToSpeech.audioPlayComplete = true
        delete this.tts_fields[index].textToSpeech.currentTime
        this.tts_fields[index].textToSpeech = {
          ...this.tts_fields[index].textToSpeech
        }
        this.audioObject.pause()
        this.audioObject.src = null
        this.audioObject = null
        this.audioObject = new Audio()
      }
    },
    resetChrono () {
      this.idleTimer = 0
    },
    async playTextToSpeech (index) {
      this.audioObject.pause()
      this.audioObject.src = null
      if (
        this.tts_fields[index].textToSpeech.hasOwnProperty(
          'audioPlayComplete'
        ) &&
        this.tts_fields[index].textToSpeech.audioPlayComplete
      ) {
        this.tts_fields[index].textToSpeech.isAudioPlaying = true
        this.audioObject.src = this.tts_fields[index].textToSpeech.audioObject
        this.tts_fields[index].textToSpeech = {
          ...this.tts_fields[index].textToSpeech
        }
      }
      if (
        this.tts_fields[index].textToSpeech.hasOwnProperty(
          'audioPlayComplete'
        ) &&
        !this.tts_fields[index].textToSpeech.audioPlayComplete
      ) {
        this.tts_fields[index].textToSpeech.isAudioPlaying = true
        this.tts_fields[index].textToSpeech.audioPlayComplete = false
        this.audioObject.currentTime = this.tts_fields[
          index
        ].textToSpeech.currentTime
        this.tts_fields[index].textToSpeech = {
          ...this.tts_fields[index].textToSpeech
        }
        this.audioObject.src = this.tts_fields[index].textToSpeech.audioObject
      } else {
        if (
          !this.tts_fields[index].textToSpeech.hasOwnProperty('audioObject')
        ) {
          await this.getTextToSpeech(index)
        }
      }
      this.currentPlayingIndex = index
      this.play(index)
    },

    setTimer (event) {
      clearTimeout(this.idleInterval)
      this.idleInterval = setTimeout(() => {
        let lastIndex = event.target.id.indexOf('-')
        let index = event.target.id.substr(
          lastIndex + 1,
          event.target.id.length
        )
        this.$store.dispatch('updateTimeLine', {
          ...this.$store.state.inspector,
          textToSpeech: this.tts_fields
        })
        if (this.tts_fields[index].textToSpeech.text.length) {
          this.getTextToSpeech(index)
          // this.saveToDB()
        }

        $('#targetIdle-' + index).mousemove(this.resetChrono())
        $('#targetIdle-' + index).keypress(this.resetChrono())
      }, 2000)
    },

    play (index) {
      this.currentPlayingIndex = index
      let _this = this
      this.tts_fields[index].textToSpeech.isAudioPlaying = true
      this.tts_fields[index].textToSpeech.audioPlayComplete = false
      this.audioObject.src = this.tts_fields[index].textToSpeech.audioObject
      this.audioObject.volume =
        this.tts_fields[index].textToSpeech.voiceVolume / 10 || 0.5
      this.audioObject.addEventListener('timeupdate', function () {
        if (_this.audioObject.ended) {
          _this.tts_fields[
            _this.currentPlayingIndex
          ].textToSpeech.audioPlayComplete = true
          _this.tts_fields[
            _this.currentPlayingIndex
          ].textToSpeech.isAudioPlaying = false
          delete _this.tts_fields[_this.currentPlayingIndex].textToSpeech
            .currentTime
          _this.audioObject.src = null
        }
      })
      this.audioObject.play()
      this.tts_fields[index].textToSpeech = {
        ...this.tts_fields[index].textToSpeech
      }
    },
    deleteTts (key, item) {
      var idx = this.tts_fields.indexOf(item)
      if (idx > -1) {
        this.tts_fields.splice(idx, 1)
      }
      this.reflext()
      this.$root.$emit('removeSubnode', item.id, 'TextToSpeech', this.activeModel.objectId)
    },
    setDuration (index) {
      this.tts_fields[index].textToSpeech.duration =
        this.tts_fields[index].textToSpeech.endTime -
        this.tts_fields[index].textToSpeech.startTime
      this.tts_fields.forEach((item, id) => {
        if (id < this.tts_fields.length - 1) {
          this.tts_fields[id + 1].textToSpeech.startTime =
            this.tts_fields[id + 1].textToSpeech.startTime >
            this.tts_fields[id].textToSpeech.endTime
              ? this.tts_fields[id + 1].textToSpeech.startTime
              : parseFloat(
                  this.tts_fields[id].textToSpeech.endTime.toFixed(2)
                ) + 1
          if (
            this.tts_fields[id + 1].textToSpeech.startTime >=
            this.tts_fields[id + 1].textToSpeech.endTime
          ) {
            this.tts_fields[id + 1].textToSpeech.endTime =
              parseFloat(
                this.tts_fields[id + 1].textToSpeech.startTime.toFixed(2)
              ) + 1
          }
          this.tts_fields[id + 1].textToSpeech.duration =
            this.tts_fields[id + 1].textToSpeech.endTime -
            this.tts_fields[id + 1].textToSpeech.startTime
        }
      })
    },
    copyTts (index, item) {
      this.tts_fields[index].textToSpeech.isCopied = !this.tts_fields[index]
        .textToSpeech.isCopied
      this.tts_fields.push({
        elementType: 'TextToSpeech',
        id: uuid.v1(),
        textToSpeech: {
          country: item.textToSpeech.country,
          gender: item.textToSpeech.gender,
          text: item.textToSpeech.text,
          languageCode: item.textToSpeech.languageCode,
          voiceEffect: item.textToSpeech.voiceEffect,
          voiceName: item.textToSpeech.voiceName,
          voiceVolume: item.textToSpeech.voiceVolume,
          startTime:
            parseFloat(item.textToSpeech.endTime.toFixed(2)) + parseFloat(1),
          endTime:
            parseFloat(item.textToSpeech.endTime.toFixed(2)) +
            1 +
            parseFloat(item.textToSpeech.duration),
          duration: parseFloat(item.textToSpeech.duration),
          voiceList: item.textToSpeech.voiceList,
          voiceEffects: item.textToSpeech.voiceEffects,
          isCopied: false,
          selectSingle: false
        }
      })
      this.reflext()
    },
    reflext () {
      let newChar =
        this.characters &&
        this.characters.map(char =>
          char.objectId === this.activeModel.objectId
            ? {
              ...char,
              object3DElements: 
                char.object3DElements ? [
                  ...char.object3DElements.filter(el =>
                      !el.hasOwnProperty('textToSpeech')
                    ),
                  ...this.tts_fields
                ] :
                [ ...this.tts_fields ]
            }
            : { ...char }
        )
      this.$store.dispatch('updateCharacters', newChar)
    },

    async getTextToSpeech (index) {
      let data = {
        audioConfig: {
          audioEncoding: 'LINEAR16',
          pitch: 0,
          speakingRate: 1
        },
        input: {
          text: this.tts_fields[index].textToSpeech.text
        },
        voice: {
          languageCode: this.tts_fields[
            index
          ].textToSpeech.languageCode.name.substr(0, 5),
          name: this.tts_fields[index].textToSpeech.voiceEffect
        }
      }
      let dataToSend = JSON.stringify(data)
      let url =
        'https://texttospeech.googleapis.com/v1/text:synthesize?key=AIzaSyBWLXM2n0Fs5-qWi8vKz1kJ2_VcOeGVzVs'
      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: dataToSend
      })
        .then(resp => {
          if (resp.status === 200) {
            return resp.json()
          } else {
            throw new Error('Server')
          }
        })
        .then(dataJson => {
          let audio = new Audio()
          this.tts_fields[index].textToSpeech.audioObject =
            'data:audio/ogg;base64,' + dataJson.audioContent
          audio.src = 'data:audio/ogg;base64,' + dataJson.audioContent
          this.tts_fields[index].textToSpeech.isAudioPlaying = false
          this.tts_fields[index].textToSpeech.audioPlayComplete = true
          audio.onloadedmetadata = e => {
            this.tts_fields[index].textToSpeech.endTime =
              parseFloat(this.tts_fields[index].textToSpeech.startTime) +
              parseFloat(audio.duration)
            this.tts_fields[index].textToSpeech.duration = audio.duration
            this.$store.dispatch('updateTimeLine', {
              ...this.$store.state.inspector,
              textToSpeech: this.$store.state.inspector.textToSpeech.map(d => {
                return d.id === index
                  ? {
                    ...d,
                    textToSpeech: {
                      ...d.textToSpeech,
                      endTime:
                          parseFloat(
                            this.tts_fields[index].textToSpeech.startTime
                          ) + parseFloat(this.audioObject.duration),
                      duration: this.audioObject.duration
                    }
                  }
                  : d
              })
            })
          }
        })
        .catch(err => {
          if (err === 'server') return
          console.log('The error is :' + err)
        })
    },
    getVoicesList: function (item) {
      this.clearTTSObject(item)
      this.tts_fields[item].textToSpeech.voiceList = []
      let voicesExist = []
      this.voicesData.forEach(value => {
        let index = value.description.indexOf(')')
        let country = value.description.substr(0, index + 1)
        if (
          value.description.includes(
            this.tts_fields[item].textToSpeech.gender
          ) &&
          !voicesExist.includes(country)
        ) {
          value.country = country
          this.tts_fields[item].textToSpeech.voiceList.push(value)
          voicesExist.push(country)
        }
      })
    },
    getVoiceEffects: function (index) {
      this.clearTTSObject(index)
      this.tts_fields[index].textToSpeech.voiceEffects = []
      let country =
        this.tts_fields[index].textToSpeech.country.match(/\((.*?)\)/g) ||
        this.tts_fields[index].textToSpeech.country
      this.tts_fields[index].textToSpeech.country = country
      return this.voicesData.forEach(value => {
        if (
          value.description.includes(
            this.tts_fields[index].textToSpeech.gender
          ) &&
          value.description.includes(
            this.tts_fields[index].textToSpeech.languageCode.country
          )
        ) {
          this.tts_fields[index].textToSpeech.voiceEffects.push(value)
        }
      })
    },
    clearTTSObject (item) {
      delete this.tts_fields[item].textToSpeech.audioObject
      delete this.tts_fields[item].textToSpeech.audioPlayComplete
      delete this.tts_fields[item].textToSpeech.isAudioPlaying
      delete this.tts_fields[item].textToSpeech.currentTime
    },
    getDataWithNewFields (index) {
      this.clearTTSObject(index)
      if (this.tts_fields[index].textToSpeech.text.length > 0) {
        this.getTextToSpeech(index)
      }
    },
    deleteAllTts () {
      this.tts_fields = this.tts_fields.filter(value => {
        return !value.textToSpeech.selectSingle
      })
      this.selectAll = false
      this.reflext()
    },
    checkSingleSelect () {
      this.tts_fields.forEach(value => {
        if (value.textToSpeech.selectSingle) {
          this.isSelected = true
        }
      })
    },
    deleteText (index, description) {
      if (
        this.tts_fields[index].textToSpeech.hasOwnProperty('placeHolderText') &&
        this.tts_fields[index].textToSpeech.placeHolderText === description
      ) {
        this.tts_fields[index].textToSpeech.text = ''
      }
    }
  },
  computed: {
    ...mapState(['characters'])
  },
  mounted () {
    let found = false
    for (let i = 0; i < this.characters.length; i++) {
      const char = this.characters[i]
      if (char.active) {
        this.activeModel = char
        found = true
      }
    }
    if (this.activeModel.hasOwnProperty('object3DElements')) {
      this.tts_fields = this.activeModel.object3DElements.filter(el => {
        return el.hasOwnProperty('textToSpeech')
      })
      setTimeout(() => {
        let newArray = []
        this.tts_fields.forEach((value, index) => {
          this.getVoicesList(index)
          this.getVoiceEffects(index)
          newArray.push(value)
        })
        this.tts_fields = newArray
      }, 1000)
    }
    // this.tts_fields = this.activeModel.tts
  }
}
</script>

<style scoped>
.pause {
  margin-left: 2.5px;
  margin-right: 2.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/models/tts.vue